import { SearchProject, StyledFilterIcon } from "@/components/styled";
import { faFilter } from "@fortawesome/pro-solid-svg-icons";
import { Tooltip } from "antd";
import { bool } from "prop-types";
import { useIntl } from "react-intl";

export const DropDownFilterButton = ({ isActive }) => {
  const intl = useIntl();

  return (
    <Tooltip
      title={intl.formatMessage({ id: "tableFilters.dropdownFilterTooltip" })}
    >
      <SearchProject>
        <StyledFilterIcon
          icon={faFilter}
          $active={isActive}
        />
      </SearchProject>
    </Tooltip>
  );
};

DropDownFilterButton.propTypes = {
  isActive: bool,
};
